import { render, staticRenderFns } from "./VasionGeneralModal.vue?vue&type=template&id=ff7810f0&"
import script from "./VasionGeneralModal.vue?vue&type=script&lang=js&"
export * from "./VasionGeneralModal.vue?vue&type=script&lang=js&"
import style0 from "./VasionGeneralModal.vue?vue&type=style&index=0&id=ff7810f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports